import LazyLoad from 'vanilla-lazyload';

import { isBot } from '@utilities';

const init = () => {
    if (!isBot()) {
        const myLazyLoad = new LazyLoad({
            elements_selector: '[data-lazyload]',
        });

        document.addEventListener('DOMContentLoaded', () => {
            myLazyLoad.update();
        });

        return () => myLazyLoad.update();
    }

    return () => {};
};

export default init;
